/** Best supported recording MIME type for the current browser. */
let _recordMime: string | undefined;

const CANDIDATES = [
  "audio/webm;codecs=opus",
  "audio/webm",
  "audio/mp4",
  "audio/ogg;codecs=opus",
];

const startsWith = (bytes: Uint8Array, sig: number[], offset = 0) =>
  sig.every((b, i) => bytes[offset + i] === b);

/** Sniff MIME from raw bytes; fallback to current browser's record MIME. */
export const sniffMime = (bytes: Uint8Array): string => {
  if (startsWith(bytes, [0x1a, 0x45, 0xdf, 0xa3])) return "audio/webm";
  if (startsWith(bytes, [0x66, 0x74, 0x79, 0x70], 4)) return "audio/mp4";
  if (startsWith(bytes, [0x4f, 0x67, 0x67, 0x53])) return "audio/ogg";
  return getRecordMime() || "audio/webm";
};

export const getRecordMime = (): string => {
  if (_recordMime !== undefined) return _recordMime;
  for (const mime of CANDIDATES) {
    if (MediaRecorder.isTypeSupported(mime)) {
      _recordMime = mime;
      return mime;
    }
  }
  _recordMime = "";
  return "";
};
